/**
 * @file Module to create Wizard component.
 * @requires WizardContent
 * @requires WizardFooter
 * @requires WizardSteps
 */

import { WizardContent } from './scripts/WizardContent';
import { WizardFooter } from './scripts/WizardFooter';
import { WizardSteps } from './scripts/WizardSteps';


/**
 * Class representing a wizard.
 */
export class Wizard {

  /**
   * Setup wizard properties.
   * @param {HTMLElement} element - The DOM element of the wizard.
   */
  constructor(element) {
    this.dom = {
      wizard: element,
      steps: element.querySelector('.wizard-steps'),
      content: element.querySelector('.wizard-content'),
      footer: element.querySelector('.wizard-footer')
    };
    this.steps = null;
    this.content = null;
    this.footer = null;
  }

  /**
   * Initialize the wizard.
   * @public
   */
  init() {
    if (this.dom.footer) {
      this.footer = new WizardFooter(this.dom.footer);
      this.footer.init();
    } else {
      throw new Error('Wizard footer not found!');
    }

    if (this.dom.content) {
      this.content = new WizardContent(this.dom.content);
      this.content.init();
    } else {
      throw new Error('Wizard content not found!');
    }

    if (this.dom.steps) {
      this.steps = new WizardSteps(this.dom.steps);
      this.steps.init();
    } else {
      throw new Error('Wizard steps not found!');
    }
  }

  /**
   * Destroy the wizard.
   * @public
   */
  destroy() {
    if (this.steps) {
      this.steps.destroy();
    }

    if (this.content) {
      this.content.destroy();
    }

    if (this.footer) {
      this.footer.destroy();
    }
  }

  /**
   * Go to the step with selected number.
   * @public
   * @param {number} stepNumber - Number of the step to go.
   */
  goToStep(stepNumber) {
    if (this.steps) {
      this.steps.go2Step(stepNumber);
    }
  }
}
